<template>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" @click="getRoles">
    <div class="card h-100">
      <details>
        <summary>
          <div class="card-header px-3 py-2 bg-gradient-success">
            <h6 class="mb-0 text-capitalize text-white">مدیریت نقش ها</h6>
          </div>
        </summary>
        <div class="card-body pt-2 px-2">
          <h6>نقش های کنونی:</h6>
          <hr class="horizontal dark" />
          <table class="table table-striped table-styled table-sm">
            <tbody>
              <template v-for="(r, index) in currentRoles">
                <tr v-if="!r.isDeleted">
                  <td scope="row" style="width: 10%">{{ index + 1 }}</td>
                  <td style="width: 40%">{{ r.title }}</td>
                  <td style="width: 30%">{{ r.isPersonnelDefault ? 'پیش فرض کارمندان' : '' }}</td>
                  <td style="width: 20%">
                    <button type="button" class="btn btn-sm bg-gradient-danger mb-0" @click="removeRole(r)">
                      حذف
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <hr class="horizontal dark" />
          <h6>سایر نقش ها:</h6>
          <hr class="horizontal dark" />
          <table class="table table-striped table-styled table-sm">
            <tbody>
              <tr v-for="(r, index) in otherRoles">
                <td scope="row" style="width: 10%">{{ index + 1 }}</td>
                <td style="width: 40%">{{ r.title }}</td>
                <td style="width: 30%">{{ r.isPersonnelDefault ? 'پیش فرض کارمندان' : '' }}</td>
                <td style="width: 20%">
                  <button type="button" class="btn btn-sm bg-gradient-success mb-0" @click="addRole(r)">
                    افزودن
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr class="horizontal dark" />
        </div>
      </details>
    </div>
  </div>
</template>
<script>
  import UserService from '@/services/User/User-service.js';
  import RoleService from '@/services/User/Role-service.js';

  export default {
    props: ['currentRoles', 'companyId'],
    data() {
      return {
        rolesGot: false,
        otherRoles: []
      };
    },
    watch: {
      companyId(newId, oldId) {
        if (newId !== oldId) {
          this.rolesGot = false;
          this.otherRoles = [];
          this.getRoles();
        }
      }
    },
    methods: {
      removeRole(role) {
        this.$emit('removeRole', role);

        this.otherRoles.push(role);
      },
      getRoles() {
        if (!this.rolesGot && this.companyId > 0) {
          RoleService.getRolesByCompanyId(this.companyId).then(response => {
            let result = response.data;

            if (!result.success) {
              this.$toast.error(result.message);
            }
            else {
              this.otherRoles = result.data.filter(role => this.currentRoles.map(x => x.id).indexOf(role.id) == -1)

              this.rolesGot = true;

              //this.roles = result.data;

              //this.currentRoles.forEach((role) => {
              //  let index = this.roles.map(x => x.id).findIndex((x) => { return x == role.roleId; });

              //  if (index > -1) { this.roles.splice(index, 1)
            }
          }).catch(e => {
            console.log(e);
          });
        }
      },
      addRole(role) {
        let index = this.currentRoles.map(x => x.roleId).indexOf(role.id);

        if (index == -1) {
          this.$emit('addRole', role);
        }

        index = this.otherRoles.map(x => x.id).indexOf(role.id);

        this.otherRoles.splice(index, 1);
      },
    },
    created() {
    }
  }
</script>
